import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { GpsService } from '../services/gps.service';

/**
 * Guard que bloquea el acceso a rutas si el permiso de GPS está denegado.
 * El usuario será redirigido a una página de error con instrucciones.
 */
export const gpsPermissionGuard: CanActivateFn = async (route, state) => {
    const gpsService = inject(GpsService);
    const router = inject(Router);

    // Verificar si ya hay coordenadas activas
    if (gpsService.isActive()) {
        return true;
    }

    // Verificar el estado del permiso
    const permissionState = await gpsService.checkPermission();

    if (permissionState.isPermanentlyDenied) {
        // Redirigir a página de error GPS con instrucciones
        router.navigate(['/gps-denegado'], {
            queryParams: { returnUrl: state.url }
        });
        return false;
    }

    // Intentar obtener la ubicación
    const result = await gpsService.validateAndStore();

    if (!result && gpsService.isDenied()) {
        router.navigate(['/gps-denegado'], {
            queryParams: { returnUrl: state.url }
        });
        return false;
    }

    return result;
};
